import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import Modal from 'react-modal';
import { CapisDepartamento, CapiSeleccionado, DetallesCapis } from '../utils/utils';
import logoPrivadas from "../assets/images/ubicacionPrivadas.png"
import logoPatronales from "../assets/images/ubicacionPatronales.png"
import logoPublicas from "../assets/images/ubicacionPublicas.png"
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faXmark } from '@fortawesome/free-solid-svg-icons';

function DetallesDeptoInv() {

  const { id } = useParams()
  const [capis, setCapis] = useState([]);
  const [capisDepto, setCapisDepto] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState(null)
  const [loading, setLoading] = useState(id ? true : false)
  const [selectedCapi, setSelectedCapi] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // async function getCapis() {
  //   let capis = await DetallesCapis();
  //   console.log(capis);
  //   setCapis(capis);
  // }

  useEffect(() => {
    allFunctions();
  }, []);

  async function getCapisDepto() {
    let capisDepto = await CapisDepartamento(id);
    setCapisDepto(capisDepto);
  }

  async function getSelectedCapi(id_autorizacion) {
    console.log("Cargando detalles del CAPI:", id_autorizacion); // Verificar ID
    let selectedCapi = await CapiSeleccionado(id_autorizacion);
    console.log("Detalles obtenidos:", selectedCapi); // Verificar datos recibidos
    setSelectedCapi(selectedCapi);
    setIsModalOpen(true);
  }

  useEffect(() => {
    console.log("selectedCapi actualizado:", selectedCapi);
  }, [selectedCapi]);

  const allFunctions = async () => {
    setCapis(await DetallesCapis());
    setLoading(true);
    if (id) {
      await getCapisDepto();
    }
    setLoading(false)
  }

  const icons = {
    Privado: L.icon({
      iconUrl: logoPrivadas,
      iconSize: [38, 38],
    }),
    Patronal: L.icon({
      iconUrl: logoPatronales,
      iconSize: [38, 38],
    }),
    Publico: L.icon({
      iconUrl: logoPublicas,
      iconSize: [38, 38],
    })
  }

  const CenterMap = ({ position }) => {
    const map = useMap();
    useEffect(() => {
      if (position) {
        map.flyTo(position, 12); // Cambia el centro del mapa con una animación
      }
    }, [position, map]);
    return null;
  };

  return (
    <div className="mt-14 ml-32 w-auto ml-28 mr-6">
      <div className="flex flex-col mb-2">
        <div className="flex flex-row w-auto items-center mb-4">
          <Link to="/UbicacionCapisInv" className="flex justify-start">
            <button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
          </Link>
          <p className="text-4xl font-bold text-[#063E5F] text-center pl-3">Localización de centros CAPI</p>
        </div>
        <div className='flex flex-wrap'>
          <MapContainer center={[13.794599, -88.93]} zoom={9}>
            <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
            <CenterMap position={selectedPosition} />
            {capis.map(capi => (
              <Marker
                key={capi.id_autorizacion}
                position={[capi.latitud, capi.longitud]}
                icon={icons[capi.naturaleza] || icons.Publico}
                eventHandlers={{
                  click: () => {
                    // setSelectedPosition([capi.latitud, capi.longitud]);
                    getSelectedCapi(capi.id_autorizacion);
                  }
                }}>
                <Popup>
                  {capi.nombre_establecimiento} <br />
                  Tipo: {capi.naturaleza}
                </Popup>
              </Marker>
            ))}
          </MapContainer>
          <div>
            <div className='text-center bg-[#A9DDE9]'>
              <table>
                <thead>
                  {capisDepto.map((dato, i) => {
                    return (
                      <tr>
                        <th className='border p-2'>Capis Autorizados: <span className='font-base'>{dato.departamento}</span></th>
                      </tr>
                    );
                  })}
                </thead>
                <tbody>
                  {capisDepto.map((dato, i) => {
                    return (
                      <tr key={dato.id_autorizacion}>
                        <td className='border cursor-pointer text-blue-500 underline'
                          onClick={() => getSelectedCapi(dato.id_autorizacion)}>{dato.nombre_establecimiento}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {/* MODAL CON REACT-MODAL */}
          <Modal
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            contentLabel="Detalles del CAPI"
            className="bg-white p-5 rounded-lg shadow-lg w-2/3 mx-auto mt-20"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
          >
            {selectedCapi && (
              <div className='flex flex-row justify-between w-auto'>
                {console.log(JSON.parse(selectedCapi.edades))}
                <div className='w-11/12'>
                  <div className='flex flex-row justify-between'>
                    <div className='w-full flex flex-col items-center w-2/3'>
                      <h2 className="text-xl font-bold">{selectedCapi.nombre_establecimiento}</h2>
                      <p>{selectedCapi.departamento}, {selectedCapi.municipio}</p>
                    </div>
                    <img src={selectedCapi.imagen} className='w-20' />
                  </div>
                  <hr className='border-2 border-gray-600' />
                  <div className='flex flex-row'>
                    <div className='m-3'>
                    <MapContainer center={[13.794599, -88.93]} zoom={9} className=''>
            <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
            <CenterMap position={selectedPosition} />
            {capis.map(capi => (
              <Marker
                key={capi.id_autorizacion}
                position={[capi.latitud, capi.longitud]}
                icon={icons[capi.naturaleza] || icons.Publico}
                eventHandlers={{
                  click: () => {
                    setSelectedPosition([capi.latitud, capi.longitud]);
                    // getSelectedCapi(capi.id_autorizacion);
                  }
                }}>
                <Popup>
                  {capi.nombre_establecimiento} <br />
                  Tipo: {capi.naturaleza}
                </Popup>
              </Marker>
            ))}
          </MapContainer>
                    </div>
                    <div className='mt-2'>
                    <p>Número de autorización: {selectedCapi.id_autorizacion}</p>
                    <hr className='border-2 border-[#949191]'/>
                    <p>Naturaleza: {selectedCapi.naturaleza}</p>
                    <hr className='border-2 border-[#949191]'/>
                    <p>Dirección: {selectedCapi.calle}, {selectedCapi.colonia}, {selectedCapi.distrito}, {selectedCapi.municipio}, {selectedCapi.departamento}</p>
                    </div>
                  </div>
                  <hr/>
                  <div className='flex flex-row justify-between'>
                    <div><h1>Capacidad:</h1><p>{selectedCapi.capacidad} Niños/as</p></div>
                    <hr className='border-2 border-[#949191] h-auto'/>
                    <div><h1>Matrícula:</h1><p>${selectedCapi.matricula}</p></div>
                    <hr className='border-2 border-[#949191] h-auto'/>
                    <div><h1>Mensualidad:</h1> <p>${selectedCapi.capacidad}</p> </div>
                    <hr className='border-2 border-[#949191] h-auto'/>

<div><h1>Atienden edades:</h1>{JSON.parse(selectedCapi.edades).map((item) =>{
  return <p> *{item}</p>
})}</div>
                    <hr className='border-2 border-[#949191] h-auto'/>
                    <div><h1>Teléfonos:</h1><p>{selectedCapi.telefono_fijo}<br/>{selectedCapi.telefono_movil}</p></div>
                  </div>
                </div>
                <div>
                  <button
                    className="m-3 text-white p-4 rounded-full bg-[#E3087F] flex items-center justify-center w-[30px] 2xl:w-[50px] h-[30px] 2xl:h-[50px]"
                    onClick={() => setIsModalOpen(false)}
                  >
                    <FontAwesomeIcon icon={faXmark} className="text-lg 2xl:text-2xl" />
                  </button>
                </div>
              </div>
            )}
          </Modal>
        </div>
      </div>
    </div>
  );
}

export default DetallesDeptoInv;
